import { render, staticRenderFns } from "./VoiceOnAlarm.vue?vue&type=template&id=3daa015f&scoped=true&"
import script from "./VoiceOnAlarm.vue?vue&type=script&lang=js&"
export * from "./VoiceOnAlarm.vue?vue&type=script&lang=js&"
import style0 from "./VoiceOnAlarm.vue?vue&type=style&index=0&id=3daa015f&lang=scss&scoped=true&"
import style1 from "./VoiceOnAlarm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daa015f",
  null
  
)

export default component.exports